import { TooltipProvider as WDSTooltipProvider } from "@datamole/wds-component-tooltip";

import { Tooltip as TooltipRoot } from "@/components/ui/Tooltip/Tooltip";

const Tooltip = Object.assign(TooltipRoot, {
    Provider: WDSTooltipProvider,
});

export { Tooltip };
